import React from "react";

const LoadingScreen = () => (
    <div className="flex h-full min-h-[200px] w-full items-center justify-center bg-surface p-8">
        <div
            role="status"
            aria-label="loading"
            className="h-10 w-10 animate-spin rounded-full border-2 border-accent/20 border-t-accent"
        />
    </div>
);

export default LoadingScreen;
